var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 7.2V6C18.0004 2.6916 15.3088 0 12.0004 0C8.69199 0 6.00039 2.6916 6.00039 6V9.6H4.80039C3.47679 9.6 2.40039 10.6764 2.40039 12V21.6C2.40039 22.9236 3.47679 24 4.80039 24H19.2004C20.524 24 21.6004 22.9236 21.6004 21.6V12C21.6004 10.6764 20.524 9.6 19.2004 9.6H8.40039V6C8.40039 4.0152 10.0156 2.4 12.0004 2.4C13.9852 2.4 15.6004 4.0152 15.6004 6V7.2H18.0004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.6bf190967c54590a6fbdb9a27e3c1999.svg";
export { ForwardRef as ReactComponent };